<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'list-perangkat'" :bg-grey="true">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Perangkat WA" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:skeleton v-if="isFetching && !isLoadMore">
                <div class="p-x-20 p-y-16 w-limit">
                    <CardSkeleton />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-x-20">
                    <div class="card_breadcrum p-t-16">
                        <SOHeaderList :title="`${totalPerangkat} Perangkat`" />
                    </div>
                    <div v-if="totalPerangkat > 0">
                        <CardPerangkat :data-list="listPerangkat" />
                    </div>
                    <div>
                        <div class="flying-button-wrapper" v-if="validateAccess('whatsappDevice.create')">
                            <div class="flying-inside">
                                <a class="flying-button" @click="gotoAddPerangkat"></a>
                            </div>
                        </div>
                    </div>
                    <SOLoadMoreLoading :id="'load-more-mesin-edc'" :loading="isLoadMore" />
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

import CardSkeleton from "../components/CardSkeleton.vue";
import CardPerangkat from "../components/CardPerangkat.vue";

import { moduleName } from "../store/state";

export default {
    name: "ListPerangkat",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOHeaderList,
        SOLoadMoreLoading,
        CardSkeleton,
        CardPerangkat,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === "wa_autosender.welcome_page") {
                vm.resetListPerangkat();
            }
        });
    },
    mounted() {
        this.init();
        this.scrollTo();
        this.smartTrackingView("perangkat_whatsapp");

    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== "dashboard") {
            this.setLastItem();
        }
        next();
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            listPerangkat: "listPerangkat",
            totalPerangkat: "totalPerangkat",
            endItemofPage: "endItemofPage",
            displayItem: "displayItem",
        }),
    },
    methods: {
        ...mapActions({
            getListPerangkat: `${moduleName}/getListPerangkat`,
            setEndItemofPage: `${moduleName}/setEndItemofPage`,
            resetListPerangkat: `${moduleName}/resetListPerangkat`,
            resetPagination: `${moduleName}/resetPagination`,
            resetRegistered: `${moduleName}/resetRegistered`,
        }),
        init() {
            if (this.listPerangkat.length === 0) {
                this.resetPagination();
                this.getListPerangkat();
            }
        },
        back() {
            this.$router.push({ name: "dashboard" });
        },
        gotoAddPerangkat() {
            this.resetRegistered();
            this.$router.push({ name: "wa_autosender.register.step1" });
            this.smartTrackingClick("add_perangkat_whatsapp");
        },
        scrollTo() {
            let el = document.getElementById(this.endItemofPage.id);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                }, 100);
            }
        },
        setLastItem() {
            let newDP = this.displayItem.sort(function(a, b) {
                if (a.yDir < b.yDir) {
                    return -1;
                }
                if (a.yDir > b.yDir) {
                    return 1;
                }
                return 0;
            });

            if (newDP[0]) {
                this.setEndItemofPage(newDP[0]);
            }
        },
    },
};
</script>
